import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { message, Modal, notification } from 'ant-design-vue' /// es/notification
import { VueAxios } from './axios'
import { ACCESS_TOKEN, REPORT_TOTAL_NUMBER } from '@/store/mutation-types'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/checkApi', // api base_url
  // baseURL: "http://47.116.112.52:8087/",
  timeout: 60000, // 请求超时时间
})

const err = (error) => {
  console.log(error)
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)

    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message,
      })
    }
    if (error.response.status === 500) {
      if (data.message.length > 0) {
        message.error(data.message)
      }
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed',
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  console.log(error)
  return Promise.reject(error)
}

// 请求拦截器
service.interceptors.request.use((config) => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  } else {
    config.headers['Authorization'] = ''
  }
  return config
}, err)

// 响应拦截器
service.interceptors.response.use((response) => {
  if (response.request.responseType === 'blob') {
    return response
  }
  console.log(response.data)

  const code = response.data.code
  if (code === 1011006 || code === 1011007 || code === 1011008 || code === 1011009 || code === 101100700) {
    Modal.error({
      title: '提示：',
      content: response.data.message,
      okText: '重新登录',
      onOk: () => {
        Vue.ls.remove(ACCESS_TOKEN)
        Vue.ls.remove(REPORT_TOTAL_NUMBER)
        window.location.reload()
      },
    })
  } else if (code === 1013002 || code === 1016002 || code === 1015002) {
    message.error(response.data.message)
    return response.data
  } else {
    if (code && code != 200) {
      message.error(response.data.message)
    }
    return response.data
  }
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  },
}

export { installer as VueAxios, service as axios }
